export interface FetchResponseLike {
  ok: boolean;
  status: number;
  text(): Promise<string>;
}

export interface FetchInit {
  body?: string;
  headers: Record<string, string>;
  method: string;
  signal?: AbortSignal;
}

export type FetchLike = (url: string, init: FetchInit) => Promise<FetchResponseLike>;

export function resolveFetch(injected?: FetchLike): FetchLike | undefined {
  if (injected) {
    return injected;
  }
  const globalFetch = (globalThis as { fetch?: unknown }).fetch;
  if (typeof globalFetch === 'function') {
    return (globalFetch as FetchLike).bind(globalThis);
  }
  return undefined;
}

export function makeAbortController(): AbortController | undefined {
  const Ctor = (globalThis as { AbortController?: typeof AbortController }).AbortController;
  return Ctor ? new Ctor() : undefined;
}

export const defaultSleep = (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}
